import React from 'react';

export default function IvrClinicSelection({
  liveAdmin,
  clinicLoad,
  master,
  repHasNoClinics,
  clinics,
  clinic,
  setClinic,
  t,
}) {
  if (liveAdmin) return null;
  return (
    <>
      {clinicLoad === 'error' && (
        <div
          role="alert"
          className="mb-4 px-3 py-2 rounded-[8px] bg-[rgba(254,226,226,0.6)] text-[12px] text-[#f23e41]"
        >
          {t(
            master
              ? 'This distributor customer is unavailable. Close this form and refresh Customers before trying again.'
              : 'Could not load clinics. Please close and reopen to try again - submission is blocked until the clinic list loads.'
          )}
        </div>
      )}
      {repHasNoClinics && (
        <div
          role="alert"
          className="mb-4 px-3 py-2 rounded-[8px] bg-[rgba(254,226,226,0.6)] text-[12px] text-[#f23e41]"
        >
          {t('No clinics are assigned to you. Contact an administrator before submitting.')}
        </div>
      )}
      {clinics.length === 1 && (
        <div className="mb-4">
          <p className="text-[12px] font-medium text-[#0f172a] mb-1">
            {t(master ? 'Customer' : 'Clinic')}
          </p>
          <div
            data-testid="clinic-fixed"
            className="w-full h-[40px] flex items-center border border-[#e2e8f0] rounded-[8px] px-3 text-[13px] text-[#0f172a] bg-[#f7f8fb]"
          >
            {clinics[0].name}
          </div>
        </div>
      )}
      {clinics.length > 1 && (
        <div className="mb-4">
          <p className="text-[12px] font-medium text-[#0f172a] mb-1">
            {t('Clinic')} <span className="text-[#f23e41]">*</span>
          </p>
          <select
            value={clinic}
            onChange={(e) => setClinic(e.target.value)}
            aria-label={t('Clinic')}
            className="w-full h-[40px] border border-[#d6dce8] rounded-[8px] px-2 text-[13px] text-[#0f172a] bg-white focus:outline-none focus:ring-2 focus:ring-[#0089ff]/20 focus:border-[#0089ff]"
          >
            <option value="">{t('Select clinic...')}</option>
            {clinics.map((c) => (
              <option key={c._id} value={c._id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </>
  );
}
